<template>
  <el-card class="box-card" v-loading="isLoading">
    <div slot="header" class="clearfix">
      <span class="form-header">Indicador - Ordenação</span>
    </div>
    <div class="row">
      <div class="col">
        <draggable element="el-collapse" :list="indicadores" :options="{draggable:'.item'}">
          <el-card>
            <el-header>Lista</el-header>
            <el-row>
              <el-col  class="item" v-for="e in list"  :key="e.id">
                   <div>{{e.nome}}</div>
              </el-col>
            </el-row>
          </el-card>
        </draggable>
      </div>
    </div>
  </el-card>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import draggable from 'vuedraggable'

  export default {
    name: "Sorting",
    components: {draggable},
    data() {
      return {
        isLoading: false,
        indicadores: []
      }
    },
    computed: {
      ...mapState('Indicador', ['list'])
    },
    methods: {
      ...mapActions('Indicador', ['setList']),
      afterInsert() {

      }
    },
    async mounted() {
      await this.setList()
      this.indicadores = collect(this.list).map(item => ({key: item.id, title: item.nome})).all()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Indicador/Sorting.vue